import { mediaQueryDown } from 'components/utils/breakpoint'
import { rem } from 'polished'
import styled from 'styled-components'
import zIndex from 'styles/tools/z-index'

const PaneResizer = styled.div`
  width: ${rem(8)};
  margin-inline: ${rem(-4)};
  cursor: col-resize;
  align-self: stretch;
  opacity: 0;
  transition: opacity 0.2s ease;
  background: ${(props) => props.theme.palette.neutral.default.three};
  user-select: none;
  z-index: ${zIndex.draggingItem};
  
  &:hover {
    opacity: 0.4;
  }

  ${mediaQueryDown.tablet} {
    display: none;
  }
`

export default PaneResizer
